var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leftMenuContainer"},[_c('div',{staticClass:"leftMeau",class:_vm.hideMainSide ? 'hide' : ''},[_c('div',{staticStyle:{"height":"100%","text-align":"center"}},[_c('img',{staticClass:"logo",attrs:{"src":_vm.$appLogo,"onerror":`this.src='${_vm.$defaultLogo}'`}}),_c('navMenu',{on:{"isshow":_vm.isshow}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }